var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoneAll = function SvgDoneAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.949 4.503a.747.747 0 0 0-1.058 0l-4.23 4.23L8.72 9.791l4.23-4.238a.75.75 0 0 0 0-1.05m3.18-.007-7.41 7.41-2.61-2.603a.747.747 0 1 0-1.058 1.058l3.135 3.135a.747.747 0 0 0 1.058 0l7.942-7.935a.747.747 0 0 0 0-1.058h-.007a.73.73 0 0 0-1.05-.007M.814 10.368l3.135 3.135a.747.747 0 0 0 1.057 0l.525-.525-3.66-3.675a.747.747 0 0 0-1.057 0 .756.756 0 0 0 0 1.065"
  })));
};
export default SvgDoneAll;